import React from 'react';
import { useEventNotificationsStore } from './use-event-notifications';

export function useSyncEventNotifications(): void {
    const eventNotificationsStore = useEventNotificationsStore();
    React.useEffect(() => {
        eventNotificationsStore.requestEventNotificationsState();
    }, [eventNotificationsStore]);
}
